import { NextPageContext } from 'next';

import ListCollection from 'types/redux/ListCollection';

import Article, { Roles } from 'models/Article';
import ArticleCategory from 'models/ArticleCategory';
import CmsPage from 'models/CmsPage';

import { list as listArticles } from 'requests/articles';
import { list as listArticlesCategories } from 'requests/articlesCategories';
import { single as singleCmsPage } from 'requests/cmsPages';

import Component from './component';
import { Props } from './types';

Component.getInitialProps = async (appContext: NextPageContext): Promise<Props> => {
    let articles: ListCollection<Article> = null;
    let articleCategories: ListCollection<ArticleCategory> = null;
    let cmsPage: CmsPage = null;

    try {
        await Promise.all([
            listArticles({ role: Roles.Worker, page: 1, perPage: 6, categorySlug: appContext?.query?.articleCategorySlug.toString() }),
            listArticlesCategories({  page: 1, perPage: 999 }),
            singleCmsPage({ slug: 'categoryarticlesemployee' }),
        ]).then(responses => {
            articles = responses[0];
            articleCategories = responses[1];
            cmsPage = responses[2];
        });
    } catch (error) {
        console.error(error);
    }

    return {
        articles,
        articleCategories: articleCategories?.elements || null,
        cmsPage: cmsPage || null,
    };
};

export default Component;
